module.exports = __webpack_public_path__ + "img/fique-por-dentro.902a60fc.svg";